import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ListingTimeline } from 'app/models/listing-timeline';
import Listable from 'app/mixins/listable';
import { InlineCarouselOptions } from 'app/models/inline-carousel';

class ListableListingTimeline extends Listable(ListingTimeline) { }

@Component({
  selector: 'listing-tile',
  templateUrl: './listings-tile.component.html',
  styleUrls: ['./listings-tile.component.scss']
})
export class ListingsTileComponent implements OnInit {

  @Input() listingTimeline: ListingTimeline;
  @ViewChild('swiper', { static: false }) swiper: any;
  listableListingTimeline: ListableListingTimeline;

  inlineCarouselOptions: InlineCarouselOptions = {
    useThumb: true,
    slidesPerView: 1,
    breakpoints: {}
  }


  constructor() { }

  ngOnInit() {
    this.listableListingTimeline = new ListableListingTimeline(this.listingTimeline);
  }

  goToListing(event: any) {

    // No way to prevent navigation click propogation on navigation element click (causing a click on the
    // parent element triggering a navigation to the listing page), so having
    // to do it manually for now. https://github.com/nolimits4web/swiper/issues/2460 is the only
    // resource I found, did not work.
    // May 2021: previous solution checking the class selector stopped working.
    if (event.target.nodeName === 'path' || event.target.nodeName === 'svg') return;

    window.open(`${this.listableListingTimeline.listing_url}`, '_blank');
  }

  goToSavingsPage(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    window.open('https://houwzer.com/sell?utm_source=listing_page', '_blank');
  }

}
